import React from 'react';
import ReactDOM from 'react-dom/client';
import "./assets/css/bootstrap.css"
import "./assets/css/revolution-slider.css"
import "./assets/css/style.css"
import "./assets/css/responsive.css"
import "./assets/css/styles.scss"
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <React.StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
